import styled from 'styled-components';
import Clearspace from '@assets/images/logo/clearspace.svg'; 

export const ClearspaceImg = styled(Clearspace)`
`;
